import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { NotFoundComponent } from './pages/other-pages/not-found/not-found.component';
import { roleHomeGuard } from './core/guards/role-home.guard';

export const routes: Routes = [

  /* =======================
   * Auth (Login / Register)
   * ======================= */
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./features/auth/auth.routes')
        .then(c => c.AUTH_ROUTES),
  },

  /* =======================
   * Admin CMS
   * ======================= */
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.routes')
        .then(c => c.ADMIN_ROUTES),
  },

  /* =======================
   * Website
   * ======================= */
  {
    path: '',
    canActivate: [roleHomeGuard],
    loadChildren: () =>
      import('./website/website.routes')
        .then(c => c.WEBSITE_ROUTES),
  },

  /* =======================
   * 404
   * ======================= */
  {
    path: '**',
    component: NotFoundComponent,
  },

];



